import React, { useEffect } from 'react';
import { ISingleImageUploadProps } from 'types';
import { Input } from 'antd';
import "./style.scss";
import { getBase64Img } from "utils";
import { FileImageOutlined } from '@ant-design/icons';

export const SingleImageUpload: React.FC<ISingleImageUploadProps> = ({ showImgURL, imageWidth="50%", onChange }) => {

  return (
    <div className='single-image-upload-container d-flex flex-column justify-content-center text-center'>
      <div>
        {showImgURL ? (
          <img src={showImgURL} alt="" width={imageWidth}/>
        ) : (
          <FileImageOutlined style={{ fontSize: '50px' }}/>
        )}
      </div>
      <div className='d-flex justify-content-center'>
        <label
          htmlFor="avatar"
          className="single-image-upload-container__btn"
          onClick={() => {
            console.log('clique')
          }}
        >
          Escolha uma imagem
        </label>
        <Input
          id="avatar"
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={(e) => {
            if (e.target.files?.[0]) {
              getBase64Img(e.target.files?.[0] as Blob, onChange);
            }
          }}
        />
      </div>
    </div>
  );
};
